/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FileManagementDetailFileResponse } from "./FileManagementDetailFileResponse";

export type FileManagementDetailFileResponseApiRespoonse = {
  data?: FileManagementDetailFileResponse;
  status?: FileManagementDetailFileResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FileManagementDetailFileResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
